import { Box, Text } from '@rbilabs/universal-components';

export const ReloadWrapper = Box.withConfig({
  marginX: 0,
  marginY: '$4',
});

export const InstructionText = Text.withConfig({
  marginTop: '$3',
  marginX: 0,
  marginBottom: '$2.5',
  fontSize: 'sm',
  width: '100%',
  padding: 0,
  fontWeight: '700',
});

export const LoadContainer = Box.withConfig({
  marginTop: '$6',
});
